import { render, staticRenderFns } from "./status-bar.vue?vue&type=template&id=db522a30&scoped=true"
import script from "./status-bar.vue?vue&type=script&lang=js"
export * from "./status-bar.vue?vue&type=script&lang=js"
import style0 from "./status-bar.vue?vue&type=style&index=0&id=db522a30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db522a30",
  null
  
)

export default component.exports